<div class="form_input-time">
  <input class="form_input is-hours" type="number" min="0" step="1" [formControl]="heuresControl" [ngClass]="{'is-invalid': !this.heuresControl.valid}"/>
  <span>h</span>
  <input class="form_input is-minutes"  type="number" min="0" max="59" step="1" [formControl]="minutesControl" [ngClass]="{'is-invalid': !this.minutesControl.valid}"/>
  <span>mins</span>
</div>
